import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachTroCapActionsObj } from "../../action-types/tro-cap/IDanhSachTroCapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachTroCapActions = {
  ...generateActions(eDanhSachTroCapActionsObj, "DANH_SACH_TRO_CAP"),
  ...generateActionForKey(
    eDanhSachTroCapActionsObj,
    "DANH_SACH_TRO_CAP",
    "DUYET_SUCCESS",
    () => {
      NotifyHelper.Success("Duyệt thành công");
    }
  ),
  ...generateActionForKey(
    eDanhSachTroCapActionsObj,
    "DANH_SACH_TRO_CAP",
    "HUY_DUYET_SUCCESS",
    () => {
      NotifyHelper.Success("Hủy duyệt thành công");
    }
  ),
};
